import axios from "axios";

const API_BASE = process.env.REACT_APP_API_URL || "https://scannerspro.duckdns.org/api";
// 🔹 Jogos ao vivo// 🔹 Jogos ao vivo
export const getLiveGames = async () => {
  const res = await axios.get(`${API_BASE}/live-games`);
  return res.data;
};

// 🔹 Jogos futuros (com indicadores)
export const getFutureGames = async (from, to) => {
  const res = await axios.get(`${API_BASE}/future-games-stats`, {
    params: { from, to }
  });
  return res.data;
};

// 🔹 Atualizar times
export const getTeams = async () => {
  const res = await axios.get(`${API_BASE}/update-teams`);
  return res.data;
};

// 🔹 Últimos jogos de um time específico
export const getUltimos = async (team) => {
  const res = await axios.get(`${API_BASE}/ultimos/${team}`);
  return res.data;
};

// 🔹 Postar contexto defensivo
export const postDefesa = async (contexto) => {
  const res = await axios.post(`${API_BASE}/defesa`, { contexto });
  return res.data;
};
